export const DEFAULT_BRAND_SEARCH = 'A.*';
